// @ts-nocheck
/**
 * Testimonials Slider & Carousel Controller
 */
function initTestimonialsSection(section) {
  if (!section) return;

      /* ========================================================
         MIDDLE FEATURED CAROUSEL
         ======================================================== */

      const featuredSlider =
        section.querySelector(
          '[data-featured-slider]'
        );


      if (featuredSlider) {

        const featuredCards =
          Array.from(
            featuredSlider.querySelectorAll(
              '[data-testimonial-featured]'
            )
          );


        const featuredNext =
          featuredSlider.querySelector(
            '[data-featured-next]'
          );


        const featuredPrev =
          featuredSlider.querySelector(
            '[data-featured-prev]'
          );


        let featuredIndex = 0;

        let featuredTimer = null;


        const featuredInterval =
          parseInt(
            featuredSlider.dataset.interval,
            10
          ) || 2000;


        function showFeatured(index) {

          if (!featuredCards.length) {
            return;
          }


          if (index >= featuredCards.length) {
            index = 0;
          }


          if (index < 0) {
            index =
              featuredCards.length - 1;
          }


          featuredCards.forEach(
            function (card, cardIndex) {

              card.classList.toggle(
                'is-active',
                cardIndex === index
              );

            }
          );


          featuredIndex = index;

        }


        function nextFeatured() {

          showFeatured(
            featuredIndex + 1
          );

        }


        function previousFeatured() {

          showFeatured(
            featuredIndex - 1
          );

        }


        function startFeaturedTimer() {

          if (featuredCards.length <= 1) {
            return;
          }


          clearInterval(
            featuredTimer
          );


          featuredTimer =
            setInterval(
              nextFeatured,
              featuredInterval
            );

        }


        function stopFeaturedTimer() {

          clearInterval(
            featuredTimer
          );

        }


        if (featuredNext) {

          featuredNext.addEventListener(
            'click',
            function () {

              nextFeatured();

              startFeaturedTimer();

            }
          );

        }


        if (featuredPrev) {

          featuredPrev.addEventListener(
            'click',
            function () {

              previousFeatured();

              startFeaturedTimer();

            }
          );

        }


        featuredSlider.addEventListener(
          'mouseenter',
          stopFeaturedTimer
        );


        featuredSlider.addEventListener(
          'mouseleave',
          startFeaturedTimer
        );


        showFeatured(0);

        startFeaturedTimer();

      }


      /* ========================================================
         RIGHT CONTINUOUS VERTICAL SCROLLER
         ======================================================== */

      const sideSlider =
        section.querySelector(
          '[data-side-slider]'
        );


      if (sideSlider) {

        const sideTrack =
          sideSlider.querySelector(
            '[data-side-track]'
          );


        if (sideTrack) {

          const originalCards =
            Array.from(
              sideTrack.querySelectorAll(
                '[data-testimonial-side]'
              )
            );


          /*
           * Continuous scrolling needs at least
           * two cards.
           */
          if (originalCards.length > 1) {

            /*
             * Duplicate the complete set.
             *
             * 1
             * 2
             * 3
             * 1
             * 2
             * 3
             *
             * This creates the seamless loop.
             */

            originalCards.forEach(
              function (card) {

                const clone =
                  card.cloneNode(true);

                /*
                 * Prevent Shopify editor attributes
                 * from being duplicated.
                 */
                clone.removeAttribute(
                  'data-shopify-editor-block'
                );


                /*
                 * Cloned cards are not editor
                 * selectable.
                 */
                clone.removeAttribute(
                  'shopify_attributes'
                );


                sideTrack.appendChild(
                  clone
                );

              }
            );


            /*
             * Calculate dimensions after
             * browser layout.
             */

            requestAnimationFrame(
              function () {

                const firstCard =
                  originalCards[0];


                if (!firstCard) {
                  return;
                }


                /*
                 * Get the actual gap from CSS.
                 */

                const computedStyle =
                  window.getComputedStyle(
                    sideTrack
                  );


                const gap =
                  parseFloat(
                    computedStyle.rowGap ||
                    computedStyle.gap ||
                    0
                  );


                /*
                 * Calculate the complete height
                 * of the original group.
                 */

                let firstGroupHeight = 0;


                originalCards.forEach(
                  function (card) {

                    firstGroupHeight +=
                      card.getBoundingClientRect().height;

                  }
                );


                /*
                 * There is one gap between each
                 * original card.
                 *
                 * Example:
                 *
                 * Card 1
                 * gap
                 * Card 2
                 * gap
                 * Card 3
                 *
                 * So:
                 *
                 * height =
                 * card heights +
                 * number of gaps
                 */

                firstGroupHeight +=
                  gap *
                  (originalCards.length - 1);


                /*
                 * Move exactly one complete
                 * testimonial group.
                 */

                const scrollDistance =
                  -firstGroupHeight;


                sideTrack.style.setProperty(
                  '--testimonial-scroll-distance',
                  scrollDistance + 'px'
                );


                /*
                 * User setting:
                 *
                 * 5 seconds by default.
                 *
                 * This means each testimonial
                 * takes approximately 5 seconds
                 * to move through the visible
                 * cycle.
                 */

                const interval =
                  parseInt(
                    sideSlider.dataset.interval,
                    10
                  ) || 5000;


                const animationDuration =
                  (
                    interval *
                    originalCards.length
                  ) / 1000;


                sideTrack.style.animationDuration =
                  animationDuration + 's';


                /*
                 * Start continuous scrolling.
                 */

                sideTrack.classList.add(
                  'is-scrolling'
                );

              }
            );

          }

        }

      }

}

function initAllTestimonials() {
  document.querySelectorAll('.testimonials-section').forEach(initTestimonialsSection);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllTestimonials);
} else {
  initAllTestimonials();
}

